const required = (name: 'VITE_SUPABASE_URL' | 'VITE_SUPABASE_ANON_KEY'): string => {
  const value = import.meta.env[name];
  if (!value) throw new Error(`${name} is required`);
  return value;
};

export const config = {
  supabaseUrl: required('VITE_SUPABASE_URL'),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY'),
  mapboxToken: import.meta.env.VITE_MAPBOX_TOKEN ?? '',
  e2e: import.meta.env.VITE_E2E_MODE === 'true',
} as const;
